/*
 * Copyright (c) 2025 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, March 26th 2025, 8:37:31 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { truncate } from "lodash";
import { APIMany2ManyFormInput, ConcreteAPIMany2ManyInputProps, CheckBoxSelectorWithChips } from "ui-widgets";
import { APISERVICEPATHS } from "lib/api";
import { ContentTag } from "lib/schemas";
import { useGetScreenProperties } from "lib/utils";
import ListItemText from "@mui/material/ListItemText";

export const GeneralContentTagsMany2ManyPicker = <T,>(props: ConcreteAPIMany2ManyInputProps<T, ContentTag>) => {
  const screenProperties = useGetScreenProperties();
  let truncateSize = 0;
  switch (screenProperties.deviceTypeGuess) {
    case "desktop":
      truncateSize = 16;
      break;
    case "tablet":
      truncateSize = 16;
      break;
    case "mobile":
      truncateSize = 28;
      break;
    case "4kTV":
      truncateSize = 0;
      break;
    default:
      truncateSize = 0;
  }

  return (
    <APIMany2ManyFormInput<T, ContentTag>
      apiServicePath={APISERVICEPATHS.contentTags}
      apiQueryParams={{ all_tags: true, type: "portal" }}
      filterByGlobalOrganization={false}
      itemIdProperty="id"
      getOptionComponent={(option) => <ListItemText primary={option.name} />}
      {...props}
      useProgressWrapper
    >
      {({ filteredItems, selectedItemIds, onCheckItem }) => (
        <CheckBoxSelectorWithChips
          values={selectedItemIds}
          options={filteredItems
            .sort((a, b) => {
              if (a.order < b.order) return -1;
              if (a.order > b.order) return 1;

              // orders are equal, sort by name
              if (a.name < b.name) return -1;
              if (a.name > b.name) return 1;

              return 0;
            })
            .map((tag) => tag.id)}
          onClickItem={(tagId) => onCheckItem(tagId)}
          getOptionLabel={(tagId) => {
            const tag = filteredItems.find((t) => t.id === tagId);

            return truncateSize ? truncate(tag.name, { length: truncateSize, omission: "..." }) : tag.name;
          }}
        />
      )}
    </APIMany2ManyFormInput>
  );
};
